import React from 'react';
export const DevToolsProvider = function Container({ children }) { return React.createElement(React.Fragment, null, children); };
